import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import StatusTag from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag';
import { Icon } from '@/src/tools/icon';
import arrayMove from 'array-move';
import { cloneDeep } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { SectionCollapse } from 'src/components/Antd';
import EditDraggableTable from 'src/components/DroppableTable/EditDraggableTable';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import {
  i18nGet,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
} from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
const PromotionTag = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, isPrimary, disabled } = props;
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());

  const h = useHistory();
  const p: any = useParams();
  const { saleChannelUuid: uuid } = p;
  const renderTitle = () => {
    return (
      <div className={css.title}>
        <div className={'collapseTitle'}>
          {getI18n('salesChannelProductDetail.index.productPromotionTag')}
        </div>
      </div>
    );
  };
  const col = [
    {
      title: getI18n('salesChannelProductDetail.index.tagTitle'),
      dataIndex: 'title',
      key: 'title',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { title } = record;
        return (
          <NoWrapContainer>
            <Tooltip title={title}>{title}</Tooltip>
          </NoWrapContainer>
        );
      },

      minWidth: 350,
    },
    {
      titleGenerate: () => getI18n('general.status'),
      position: EnumTablePosition.mid,
      key: 'status',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { status } = record;
        return <StatusTag status={status} />;
      },

      fixedWidth: 160,
    },
    {
      title: `${getI18n(
        'salesChannelProductDetail.index.startTime',
      )} (UTC ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'createdTime',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { startTime } = record;
        const t = handleOnFormatCurrentSCTimeAndDateWithTimezone(startTime);
        return startTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },

      fixedWidth: 200,
    },
    {
      title: `${getI18n(
        'salesChannelProductDetail.index.endTime',
      )} (UTC ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'finishTime',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { endTime } = record;
        const t = handleOnFormatCurrentSCTimeAndDateWithTimezone(endTime);
        return endTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },
      fixedWidth: 200,
    },
    {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      dataIndex: 'action',
      default: true,
      optional: true,
      key: 'action',
      //className: css.columnClass,
      fixedWidth: 128,
      childGenerate: (text, record, index) => {
        const { uuid: tagUuid } = record;
        return (
          <Action
            onEdit={() => {
              h.push(`/salesChannel/promotionTag/editor/${uuid}/${tagUuid}`);
            }}
          />
        );
      },
    },
  ];

  const renderBottom = () => {
    return (
      <div className={css.bottom}>
        <Icon type='iconinfo' className={css.icon} />
        <span>
          {`${getI18n(
            'salesChannelProductDetail.index.gotoSalesChannelPromotionTag',
          )} >`}
          <Link to={`/salesChannel/promotionTagList/${uuid}`}>
            {getI18n('salesChannelProductDetail.index.productTag')}
          </Link>
          {getI18n('salesChannelProductDetail.index.tomanagetag')}
        </span>
      </div>
    );
  };
  const renderContent = () => {
    const hasValue =
      (data || []).reduce((pre, now) => {
        const { promotionTags } = now;
        const len = (promotionTags || []).length;
        return pre + len;
      }, 0) > 0;
    return (
      <React.Fragment>
        {hasValue && (
          <div className={css.tipContainer}>
            {getI18n('salesChannelProductDetail.index.tipContainerText')}
          </div>
        )}

        {(data || []).map((i, index) => {
          const { salesChannelProductUuid, name, promotionTags } = i || {};
          const hasValue = (promotionTags || []).length > 0;
          return hasValue ? (
            <div key={salesChannelProductUuid} className={css.tableContainer}>
              <div className={css.tableTitle}>{name}</div>
              <EditDraggableTable
                hideAllDragHandlers={!isPrimary || disabled}
                pagination={false}
                dataSource={promotionTags}
                id={`SalesChannelLinkProductVirtualStockTable`}
                columns={col}
                rowKey={'uuid'}
                onTableChange={(e, value) => {
                  const { from, to } = value;
                  const v = arrayMove(promotionTags, from, to);
                  const _data = cloneDeep(data || []);
                  _data[index].promotionTags = v;
                  // console.log('_data', _data);
                  onChange(_data);
                  // if (onChange) onChange(e, value);
                }}
              />
            </div>
          ) : null;
        })}
        <div className={css.bottomContainer}> {renderBottom()}</div>
      </React.Fragment>
    );
  };
  return (
    <SectionCollapse
      open={true}
      id={'salesChannelLinkProductVirtualStockCollapse'}
      titleStyle={{ height: '64px' }}
      title={renderTitle()}
      content={<div className={css.container}>{renderContent()}</div>}
      openMargin={16}
    />
  );
};
export default PromotionTag;
